import React, { useCallback, useEffect, useState } from 'react'
import {
    Autocomplete,
    Button,
    MenuItem,
    Select,
    TextField,
    Checkbox,
    Tooltip,
} from '@mui/material'
import FormControlLabel from '@mui/material/FormControlLabel'
import { Container, Form } from './styles'
import { Controller, useForm, SubmitHandler } from 'react-hook-form'
import swal from 'sweetalert'
import NumberFormat from 'react-number-format'
import toast from 'react-hot-toast'
import { validateData } from '../../utils/date'
import { cnpjCpfMask, foneMask } from '../../utils/masks'
import { validateCnpjCpf } from '../../utils/validate'

import * as yup from 'yup'
import { useSelector } from 'react-redux'
import { StoreState } from '../../store'
import api from '../../services/axios'
import { get } from 'lodash'
import { useNavigate } from 'react-router-dom'
import { selectedMenu } from '../../store/modules/menu/actions'
import { useDispatch } from 'react-redux'
import validator from 'validator'
import TableParcelas from '../../components/tableParcelas'
import { MdHelpOutline } from 'react-icons/md'
import dayjs from '../../libs/dayjs'

interface Inputs {
    cnpjPagador: string
    // tipoLink: string | number
    // tipoCobranca: string | number
    quantParcelas: string | number
    dataLiquidacao: string
    // contatoData: any
    observacao: string
    nomeTitular: string
    email: string
    telefone: string
}

const schema = yup.object().shape({
    cnpj_cpf: yup.string().required(),
    cnpjPagador: yup.string().required(),
    valor: yup.number().positive().not([0]).required(),
    quantParcelas: yup.number().required(),
    // tipoLink: yup.string().required(),
    // tipoCobranca: yup.number().positive().required(),
    dataLiquidacao: yup.string().required(),
    nomePagador: yup.string().required(),
    emailPagador: yup.string().required(),
    telefonePagador: yup.string(),
    tipoLink: yup.string(),
})

interface InitialContactProtocol {
    nomeTitular: string
    cnpjPagador: string
    email: string
    telefone: string
    id: undefined | string | number
}

const initialContact: InitialContactProtocol = {
    nomeTitular: '',
    cnpjPagador: '',
    email: '',
    telefone: '',
    id: undefined,
}

const LinkCriar: React.FC = () => {
    const { cnpj_cpf } = useSelector((state: StoreState) => state.auth.user)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const {
        handleSubmit,
        control,
        formState: { errors },
        register,
        setValue,
        watch,
        reset,
    } = useForm<Inputs>()
    const [valueLink, setValueLink] = useState<string | number>('')
    const [contacts, setContacts] = useState([])
    const [selectedFav, setSelectedFav] =
        useState<InitialContactProtocol>(initialContact)
    const [saveContactAsFavs, setSaveContactAsFavs] = useState(true)
    const getContact = useCallback(async () => {
        try {
            const { data } = await api.get(`/contatos/${cnpj_cpf}`)
            setContacts(data)
            const response = await api.get(
                `/institution/domicilio-pagamento/${cnpj_cpf}`
            )
            if (!response?.data?.id) {
                swal({
                    title: 'Opss!',
                    text: `Parece que você ainda não fez o cadastro dos seus dados bancários, clique aqui para cadastrar e começar a criar links!`,
                    icon: 'error',
                }).then((value) => {
                    dispatch(
                        selectedMenu({
                            mainMenu: 'Minha conta',
                            subMenu: '',
                            currentLink: '/minhaconta',
                        })
                    )
                    navigate('/minhaconta/domicilio-pagamento')
                })
            }
        } catch (error) {}
    }, [cnpj_cpf, navigate, dispatch])
    useEffect(() => {
        getContact()

        let dataPadrao = dayjs().add(12, 'd')

        if (dataPadrao.day() === 0) {
            dataPadrao = dataPadrao.add(1, 'd')
        }

        if (dataPadrao.day() === 6) {
            dataPadrao = dataPadrao.add(2, 'day')
        }
        setValue('dataLiquidacao', dataPadrao.format('YYYY-MM-DD'))
    }, [setValue, getContact])

    useEffect(() => {
        if (selectedFav?.id === undefined) {
            reset(initialContact)
            return
        }
        // deselecionar a opcao salvar
        reset({
            cnpjPagador: selectedFav?.cnpjPagador,
            nomeTitular: selectedFav?.nomeTitular,
            email: selectedFav?.email,
            telefone: selectedFav?.telefone,
        })
    }, [selectedFav, reset])

    const submit: SubmitHandler<Inputs> = async (inputs) => {
        const linkData = {
            cnpj_cpf: cnpj_cpf,
            valor: valueLink,
            quantParcelas: inputs.quantParcelas,
            cnpjPagador: inputs.cnpjPagador.replace(/\D/g, ''),
            nomePagador: inputs.nomeTitular,
            emailPagador: inputs.email,
            telefonePagador: inputs.telefone.replace(/\D/g, ''),
            dataLiquidacao: inputs.dataLiquidacao,
            observacao: inputs.observacao,
            tipoLink: 0,
        }
        const isValid = await schema.isValid(linkData)
        if (!isValid) {
            toast.error('Dados inválidos')
            return
        }

        try {
            if (saveContactAsFavs) {
                const data = {
                    cnpj_cpf,
                    nomeTitular: inputs.nomeTitular,
                    numeroDocumentoTitular: inputs.cnpjPagador.replace(
                        /\D/g,
                        ''
                    ),
                    compe: '',
                    agencia: '',
                    numeroConta: '',
                    tipoConta: '',
                    email: inputs.email,
                    telefone: inputs.telefone.replace(/\D/g, '') || '',
                    ispb: '',
                    contactId: selectedFav?.id || undefined,
                }
                await api.post('/contato', data)
            }
            const { data } = await api.post(`/link/criar`, linkData)

            swal({
                title: 'Link de pagamento criado com sucesso!',
                text: `Link de pagamento copiado para área de transferência`,
                icon: 'success',
            })

            // colocar no arquivo .env
            // const linkDePagamento = `http://localhost:3000/${data.id}`
            const linkDePagamento = `https://treeweb.com.br/producao/${data.id}`
            navigator.clipboard.writeText(linkDePagamento)
            navigate('/link/gerenciar')
        } catch (error) {
            const messageError = get(error, 'response.data.error', '')
            swal({
                title: 'Erro ao criar link de pagamento',
                text: `${messageError}`,
                icon: 'error',
            })
        }
    }
    return (
        <>
            <Container>
                <h2>Criar link de pagamento</h2>
                <Form onSubmit={handleSubmit(submit)}>
                    <div className="check-box">
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={saveContactAsFavs}
                                    onChange={(e, newValue) =>
                                        setSaveContactAsFavs(newValue)
                                    }
                                />
                            }
                            label={'Salvar este contato como favorito'}
                        />
                        <Tooltip
                            title="Marque esta opção caso queria salvar estes dados como favoritos (ao selecionar um contato favorito e deixar essa opcão habilitada seu contato será atualizado com os novos dados)."
                            placement="top"
                        >
                            <span>
                                <MdHelpOutline size={18} />
                            </span>
                        </Tooltip>
                    </div>
                    <div className="input-group">
                        <div className="input-wrapper">
                            <Controller
                                defaultValue=""
                                name="nomeTitular"
                                control={control}
                                rules={{
                                    required:
                                        'O campo nome do titular é obrigatório',
                                    minLength: 3,
                                    maxLength: 100,
                                }}
                                render={({ field }) => (
                                    <Autocomplete
                                        freeSolo
                                        onChange={(event, newValue) => {
                                            // const value: string = newValue ? newValue[0] : ''
                                            setSelectedFav({
                                                nomeTitular:
                                                    newValue?.nomeTitular,
                                                cnpjPagador:
                                                    newValue?.numeroDocumentoTitular,
                                                email: newValue?.email,
                                                telefone: newValue?.telefone,
                                                id: newValue?.id,
                                            })
                                            setSaveContactAsFavs(false)
                                        }}
                                        onInputChange={(event, value) => {
                                            // const { data } = await api.get(`/comissao/taxa/${cnpj_cpf}`)
                                            // const inputEqualSomeContato = contatos.find((contato: any) => contato.nomeTitular === value)
                                            // if(!inputEqualSomeContato) {
                                            //     return field.onChange(value)
                                            // }
                                            field.onChange(value)

                                            // setSelectedFav(inputEqualSomeContato)
                                        }}
                                        getOptionLabel={(option: any) => {
                                            return option.nomeTitular ?? option
                                        }}
                                        // isOptionEqualToValue={(option, value) => {
                                        //     return option === value
                                        // }}
                                        disablePortal
                                        id="nomeTitular"
                                        options={contacts}
                                        sx={{
                                            width: '100%',
                                            fontFamily: 'Roboto',
                                            fontSize: '18px',
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label=""
                                                placeholder="Nome do titular"
                                            />
                                        )}
                                    />
                                )}
                            />
                            {/* <Controller defaultValue='' name='nomeTitular' control={control} rules={{ required: 'O campo nome do titular é obrigatório', minLength: 3, maxLength: 100 }} render={({ field }) => <TextField {...field} className='input' id="nomeTitular" placeholder="Nome do titular" variant="outlined" />} /> */}
                            {errors.nomeTitular &&
                                errors.nomeTitular.type === 'required' && (
                                    <span className="hook-error">
                                        {errors.nomeTitular.message}
                                    </span>
                                )}
                            {errors.nomeTitular &&
                                errors.nomeTitular.type === 'minLength' && (
                                    <span className="hook-error">
                                        O campo nome do titular deve ter pelo
                                        menos 3 caracteres
                                    </span>
                                )}
                            {errors.nomeTitular &&
                                errors.nomeTitular.type === 'maxLength' && (
                                    <span className="hook-error">
                                        O campo nome do titular deve ter no
                                        máximo 100 caracteres
                                    </span>
                                )}
                        </div>
                        <div className="input-wrapper">
                            {/* <label htmlFor="cnpjPagador">CNPJ/CPF do pagador: </label> */}
                            <Controller
                                defaultValue=""
                                name="cnpjPagador"
                                control={control}
                                rules={{
                                    required:
                                        'O campo Cnpj ou Cpf é obrigatório',
                                    validate: (value: string) =>
                                        validateCnpjCpf(value),
                                }}
                                render={({ field: { value, ...field } }) => (
                                    <TextField
                                        {...field}
                                        className="input"
                                        value={cnpjCpfMask(value || '')}
                                        id="cnpjPagador"
                                        placeholder="CPF ou CNPJ"
                                        variant="outlined"
                                    />
                                )}
                            />
                            {errors.cnpjPagador &&
                                errors.cnpjPagador.type === 'required' && (
                                    <span className="hook-error">
                                        {errors.cnpjPagador.message}
                                    </span>
                                )}
                            {errors.cnpjPagador &&
                                errors.cnpjPagador.type === 'validate' && (
                                    <span className="hook-error">
                                        Cnpj ou Cpf inválido
                                    </span>
                                )}
                        </div>
                    </div>

                    <div className="input-group">
                        <div className="input-wrapper">
                            <Controller
                                defaultValue=""
                                name="email"
                                control={control}
                                rules={{
                                    required: 'O campo email é obrigatório',
                                    validate: (email: string) =>
                                        validator.isEmail(email),
                                }}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        className="input"
                                        id="email"
                                        placeholder="Email"
                                        variant="outlined"
                                    />
                                )}
                            />
                            {errors.email &&
                                errors.email.type === 'required' && (
                                    <span className="hook-error">
                                        {errors.email.message}
                                    </span>
                                )}
                            {errors.email &&
                                errors.email.type === 'validate' && (
                                    <span className="hook-error">
                                        Digite um email válido
                                    </span>
                                )}
                        </div>
                        <div className="input-wrapper">
                            <Controller
                                defaultValue=""
                                name="telefone"
                                control={control}
                                render={({ field: { value, ...field } }) => (
                                    <TextField
                                        {...field}
                                        value={foneMask(value || '')}
                                        className="input"
                                        id="telefone"
                                        placeholder="Telefone"
                                        variant="outlined"
                                    />
                                )}
                            />
                        </div>
                    </div>

                    <div className="input-group tripple">
                        <div className="input-wrapper">
                            <label htmlFor="valueLink">Digite um valor: </label>
                            <NumberFormat
                                className="border value"
                                id="valueLink"
                                thousandSeparator="."
                                decimalSeparator=","
                                thousandsGroupStyle="thousand"
                                placeholder="Ex: 10,90"
                                prefix={'R$'}
                                value={valueLink}
                                onValueChange={({
                                    formattedValue,
                                    floatValue,
                                }) => setValueLink(floatValue || 0)}
                            />
                        </div>
                        <div className="input-wrapper">
                            <label htmlFor="data">Vencimento: </label>
                            <input
                                defaultValue=""
                                id="data"
                                {...register('dataLiquidacao', {
                                    required: false,
                                    validate: (value) => validateData(value),
                                })}
                                className="date"
                                type="date"
                            />
                            {errors.dataLiquidacao &&
                                errors.dataLiquidacao.type === 'required' && (
                                    <span className="hook-error">
                                        Data inválida
                                    </span>
                                )}
                            {errors.dataLiquidacao &&
                                errors.dataLiquidacao.type === 'validate' && (
                                    <span className="hook-error">
                                        Data inválida
                                    </span>
                                )}
                        </div>

                        <div className="input-wrapper">
                            <label htmlFor="quantParcela">
                                Quantidade de parcelas:{' '}
                            </label>
                            <Controller
                                defaultValue={1}
                                control={control}
                                name="quantParcelas"
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        id="quantParcela"
                                        variant="outlined"
                                    >
                                        {/* <MenuItem value={0} disabled>Parcela - Prazo</MenuItem>
                <MenuItem value={1}>Única - 30 dias</MenuItem>
                <MenuItem value={2}>2x - 60 dias</MenuItem>
                <MenuItem value={3}>3x - 90 dias</MenuItem>
                <MenuItem value={4}>4x - 120 dias</MenuItem>
                <MenuItem value={5}>5x - 150 dias</MenuItem>
                <MenuItem value={6}>6x - 180 dias</MenuItem>
                <MenuItem value={7}>7x - 210 dias</MenuItem>
                <MenuItem value={8}>8x - 240 dias</MenuItem>
                <MenuItem value={9}>9x - 270 dias</MenuItem>
                <MenuItem value={10}>10x - 300 dias</MenuItem> */}
                                        <MenuItem value={1}>1x</MenuItem>
                                        <MenuItem value={2}>2x</MenuItem>
                                        <MenuItem value={3}>3x</MenuItem>
                                        <MenuItem value={4}>4x</MenuItem>
                                        <MenuItem value={5}>5x</MenuItem>
                                        <MenuItem value={6}>6x</MenuItem>
                                        <MenuItem value={7}>7x</MenuItem>
                                        <MenuItem value={8}>8x</MenuItem>
                                        <MenuItem value={9}>9x</MenuItem>
                                        <MenuItem value={10}>10x</MenuItem>
                                    </Select>
                                )}
                            />
                        </div>
                    </div>
                    <div className="input-group">
                        <div className="input-wrapper text-area">
                            <textarea
                                defaultValue=""
                                {...register('observacao')}
                                className="text-area"
                                name="observacao"
                                id=""
                                placeholder="Digite uma observação ou descrição"
                            ></textarea>
                        </div>
                    </div>
                    <div className="actions">
                        <Button type="submit" variant="contained">
                            Criar Link
                        </Button>
                    </div>
                </Form>
            </Container>
            {valueLink !== 0 && valueLink && (
                <TableParcelas
                    data_Liquidacao={watch('dataLiquidacao')}
                    valueLink={Number(valueLink)}
                    quantParcelas={Number(watch('quantParcelas'))}
                />
            )}
        </>
    )
}

export default LinkCriar
